<template>
  <div class="car-info">
    <ucar-title>{{title}}</ucar-title>
    <div class="photo-info">
      <div class="photo-group-title">行驶证</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.carLicense"
          v-model="photoInfo.carLicense"
          @uploadFinish="autoInputVehicleLicense"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.carLicense.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.carLicense.type) !== -1"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.carSecondLicense"
          v-model="photoInfo.carSecondLicense"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.carSecondLicense.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.carSecondLicense.type) !== -1"
        ></ucar-upload-img>
      </div>
      <div class="photo-group-title">车辆</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.car"
          v-model="photoInfo.car"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.car.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.car.type) !== -1"
        ></ucar-upload-img>
        <ucar-upload-img
          v-bind="photoBaseData.carVin"
          v-model="photoInfo.carVin"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.carVin.type]"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.carVin.type) !== -1"
        ></ucar-upload-img>
      </div>
      <div class="photo-group-title">网络预约出租汽车运输证{{needNetworkCarLicense ? '' : '（选填）'}}</div>
      <div class="photo-group">
        <ucar-upload-img
          v-bind="photoBaseData.networkCarLicense"
          :showTitle="false"
          v-model="photoInfo.networkCarLicense"
          :mode="mode"
          :error="vuexDisapproveInfo.errors[photoBaseData.networkCarLicense.type]"
          :deletable="!needNetworkCarLicense"
          :needModify="vuexDisapproveInfo.needModify.indexOf(photoBaseData.networkCarLicense.type) !== -1"
        ></ucar-upload-img>
      </div>
    </div>
    <ucar-section title="以下为自动识别图片的结果，如不正确请修改" :disabled="mode === 'modify'">
      <div class="row">
        <label>车牌号</label>
        <ucar-select
          class="car-info-region"
          :options="baseData.licencePlates"
          placeholder
          v-model="info.region"
        ></ucar-select>
        <input placeholder="请输入" v-model="info.licenceNum" maxlength="7">
      </div>
      <div class="row">
        <label>车辆所有人</label>
        <dynamic-textarea v-model="info.name" :maxlength="30" placeholder="请输入"></dynamic-textarea>
      </div>
      <div class="row">
        <label>车辆注册日期</label>
        <ucar-date-select
          v-model="info.date"
          :start-date="new Date((new Date()).getFullYear() - 10, (new Date()).getMonth(), (new Date()).getDate())"
          :end-date="new Date()"
          ></ucar-date-select>
      </div>
      <div class="row">
        <label>车型</label>
        <ucar-car-select placeholder="请选择" v-model="info.carModel"></ucar-car-select>
      </div>
      <div class="row">
        <label>车辆识别号</label>
        <input placeholder="请输入" v-model="info.vinId" maxlength="17">
      </div>
    </ucar-section>
    <div class="footer">
      <button type="button" class="btn-submit" :class="{'btn-submit-enable': enableSubmit}" @click="submit">提交</button>
    </div>
  </div>
</template>

<style lang="stylus">
.car-info {
  .car-info-region {
    width: 120px;
  }
}
</style>

<script>
import carSelect from '../../components/car-select'
import DynamicTextarea from '../../components/dynamic-textarea'
import valid from '../../utils/valid-check'
import preload from '../../utils/preload'
import { transformImgUrl } from '../../utils/transform'
import { PhotoBaseData, licencePlates } from '../../utils/constants'
import { validCarInfo, spotVehicleLicense } from '../../api'
export default {
  name: 'car-info',
  data () {
    return {
      mode: 'normal',
      info: {
        name: '',
        region: '京',
        date: '',
        licenceNum: '',
        carModel: {},
        vinId: ''
      },
      photoInfo: {
        carLicense: '',
        carSecondLicense: '',
        car: '',
        carVin: '',
        networkCarLicense: ''
      },
      photoBaseData: PhotoBaseData,
      baseData: {
        licencePlates: licencePlates
      }
    }
  },
  watch: {
    'info.licenceNum' (val) {
      this.info.licenceNum = val.replace(/[^A-Za-z\d]/g, '').toUpperCase().substr(0, 7)
    },
    'info.vinId' (val) {
      this.info.vinId = val.replace(/[^A-Za-z\d]/g, '').toUpperCase().substr(0, 17)
    }
  },
  computed: {
    needNetworkCarLicense() {
      return this.vuexCompanyId ? this.vuexCurrentCity.needCompanyNetworkCarLicense : this.vuexCurrentCity.needNetworkCarLicense
    },
    enableSubmit () {
      const errorInfo =
        valid.notEmpty(this.info.name, '车辆所有人姓名') ||
        valid.notEmpty(this.photoInfo.carLicense, '行驶证正本') ||
        valid.notEmpty(this.photoInfo.carSecondLicense, '行驶证副本') ||
        valid.notEmpty(this.photoInfo.car, '全车照片') ||
        valid.notEmpty(this.photoInfo.carVin, '车架号照片') ||
        (this.needNetworkCarLicense &&
        valid.notEmpty(this.photoInfo.networkCarLicense, '网络预约出租汽车运输证')) ||
        valid.notEmpty(this.info.date, '车辆注册日期') ||
        valid.notEmpty(this.info.vinId, '车辆识别号') ||
        valid.carNumber(this.info.licenceNum) ||
        valid.notEmpty(this.info.carModel)
      return errorInfo === ''
    }
  },
  components: {
    'ucar-car-select': carSelect,
    DynamicTextarea
  },
  methods: {
    getBaseData () {
      this.$loading.show()
      preload([
        PhotoBaseData.carLicense.defaultImg,
        PhotoBaseData.carSecondLicense.defaultImg,
        PhotoBaseData.car.defaultImg,
        PhotoBaseData.carVin.defaultImg,
        PhotoBaseData.networkCarLicense.defaultImg
      ]).then(() => {
        this.$loading.hidden()
        if (this.$route.query.mode) this.mode = this.$route.query.mode
        const cachedInfo = this.findCachedInfo()
        if (cachedInfo && cachedInfo.carInfo) {
          this.setVuexCarInfo(cachedInfo.carInfo)
        }
        if (this.mode !== 'modify' && this.vuexCarInfo !== null && typeof this.vuexCarInfo === 'object' && Object.keys(this.vuexCarInfo).length > 0) {
          this.info = this.vuexCarInfo.baseInfo
          this.photoInfo = this.vuexCarInfo.photoInfo
          return
        }
        this.modifyInit()
      })
    },
    cacheData () {
      const data = { baseInfo: this.info, photoInfo: this.photoInfo }
      this.setVuexCarInfo(data)
      this.cacheInfoForLongTime('car', data)
    },
    autoInputVehicleLicense (val) {
      spotVehicleLicense({
        imagePath: val
      }).then(res => {
        if (res.carOwner) this.info.name = res.carOwner
        if (valid.date(res.carRegisterDate)) this.info.date = res.carRegisterDate
        if (res.vinNumber) this.info.vinId = res.vinNumber
        if (res.carPlateNo) {
          const region = this.baseData.licencePlates.find(item => item.name === res.carPlateNo[0])
          this.info.region = region.value || ''
          this.info.licenceNum = res.carPlateNo.substr(1, res.carPlateNo.length - 1)
        }
      })
    },
    submit () {
      const errorInfo =
        valid.cnName(this.info.name, '请输入正确的车辆所有人名称') ||
        valid.carOwnerLimit(this.info.name) ||
        valid.carNumber(this.info.licenceNum)
      if (errorInfo) {
        this.$alert(errorInfo)
        return
      }
      if (this.mode === 'modify') {
        this.submitModify()
        return
      }
      const carInfo = {
        vehicleNo: `${this.info.region}${this.info.licenceNum}`,
        vehicleBrand: this.info.carModel.currentBrand.carIdent,
        vehicleTypeId: Number(this.info.carModel.currentModel.id),
        vehicleResponsor: this.info.name,
        vehicleResDate: this.info.date,
        onLineVehicleTransportationLicense: this.photoInfo.networkCarLicense ? 1 : 0,
        vehicleColor: Number(this.info.carModel.currentColor.id),
        carIdentificationNumber: this.info.vinId,
        mobile: this.vuexPersonMobile,
        drivingLicenseImgUrl: this.photoInfo.carLicense,
        drivingLicenseImgCopyUrl: this.photoInfo.carSecondLicense,
        vehicleUrl: this.photoInfo.car,
        vehicleFrameUrl: this.photoInfo.carVin,
        onLineVehicleTransportationLicenseUrl: this.photoInfo.networkCarLicense
      }
      // 由于接口方暂时不支持https协议的图片地址，所以将所有待上传的图片链接地址转换为http协议
      const submitInfo = transformImgUrl({ ...this.vuexSubmitInfo, ...carInfo })
      validCarInfo(submitInfo).then(res => {
        if (res.failureCode === 41) return this.handleStatusChange(res)
        if (res.isEnable) {
          this.setVuexSubmitInfo(submitInfo)
          this.cacheData()
          this.trackEvent('XQ_tjzlpage_tj_click')
          return this.finalSubmit()
        } else {
          this.$alert(res.failMess || '系统繁忙')
        }
      }).then(res => this.handleStatusChange(res))
    }
  },
  mounted () {
    this.getBaseData()
  }
}
</script>
